import { ArrowLeft, BookOpen, RotateCcw } from "lucide-react";

import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { ShareSessionDialog } from "@/components/ShareSessionDialog";
import { DebugSessionSwitcher } from "@/components/DebugSessionSwitcher";
import { isDebugMode } from "@/lib/debug";
import { useAppStore } from "@/store/app";

export function Header() {
  const reset = useAppStore((s) => s.reset);
  const guideOpen = useAppStore((s) => s.guideOpen);
  const setGuideOpen = useAppStore((s) => s.setGuideOpen);
  const debug = isDebugMode();

  return (
    <header className="sticky top-0 z-30 h-14 border-b bg-white flex items-center px-5">
      <div className="flex items-center gap-3 whitespace-nowrap">
        <div className="flex items-center gap-2">
          <Logo className="h-9 w-auto shrink-0" />
          <span className="text-[15px] font-semibold tracking-tight whitespace-nowrap">
            Appeal Letter Generation Demo
          </span>
        </div>
      </div>

      <div className="flex-1" />

      <div className="flex items-center gap-3 justify-end whitespace-nowrap">
        <Button
          variant="ghost"
          size="sm"
          className="gap-1.5"
          onClick={() => setGuideOpen(!guideOpen)}
          aria-pressed={guideOpen}
        >
          {guideOpen ? (
            <>
              <ArrowLeft className="w-3.5 h-3.5" />
              Back to Session
            </>
          ) : (
            <>
              <BookOpen className="w-3.5 h-3.5" />
              Guide
            </>
          )}
        </Button>
        {/* Debug mode swaps in the session switcher; otherwise the share
            link. The "New session" button is always available. */}
        {debug ? <DebugSessionSwitcher /> : <ShareSessionDialog />}
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button variant="ghost" size="sm" className="gap-1.5">
              <RotateCcw className="w-3.5 h-3.5" />
              New session
            </Button>
          </AlertDialogTrigger>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>Start a new session?</AlertDialogTitle>
              <AlertDialogDescription>
                This wipes all uploaded / generated documents, the agent state, and the drafted
                letter. The synthetic lock will reset, so you can choose a different scenario.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>Cancel</AlertDialogCancel>
              <AlertDialogAction onClick={() => reset()}>Yes, reset</AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </div>
    </header>
  );
}
